<template>
  <div class="signup-track">
    <p>Register:</p>
    <ul class="numbered-steps">
      <li :class="{active: step === 1}">
        <div>
          <span>Basic data</span>
          <i class='uil uil-align-center-alt'></i>
        </div>
      </li>
      <li :class="{active: step === 2}">
        <div>
          <span>SMS verification</span>
          <i class='uil uil-mobile-android'></i>
        </div>
      </li>
      <li :class="{active: step === 3}">
        <div>
          <span>Password</span>
          <i class='uil uil-lock-alt'></i>
        </div>
      </li>
    </ul>
    <div class="track-success">
      <i class="uil uil-thumbs-up primary-color" v-if="step === 4"></i>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'signup-track',
  computed: {
    ...mapFields({
      step: 'ui.signupStep'
    })
  }
}
</script>
